import type { User } from "../Types/UserTypes";
import { ADMIN_ACCESS_LEVEL, MAX_NON_ADMIN_USERS } from "./UserConstants";

export const IsAdminUser = (user: User): boolean => user.accessLevel === ADMIN_ACCESS_LEVEL;

export const IsUserLocked = (user: User): boolean => IsAdminUser(user) || user.last_login === null;

export const IsUserLimitReached = (users: User[]): boolean =>
  users.filter(user => !IsAdminUser(user)).length >= MAX_NON_ADMIN_USERS;
